import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrincipalComponent } from './principal/principal.component';
import { BannerComponent } from './banner/banner.component';

const routes: Routes = [
  { path: 'principal', component: PrincipalComponent },
  { path: 'principal/:lang', component: PrincipalComponent },
  { path: 'banner', component: BannerComponent },
  { path: 'banner/:lang', component: BannerComponent },
  { path: '', redirectTo: '/principal', pathMatch: 'full' },
  { path: '**', redirectTo: '/principal', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRouters { }
